import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const DIFFICULTY_LABELS = {
  1: { label: "Beginner", color: "text-emerald-400", bg: "bg-emerald-500/20", border: "border-emerald-500/30" },
  2: { label: "Easy", color: "text-green-400", bg: "bg-green-500/20", border: "border-green-500/30" },
  3: { label: "Moderate", color: "text-blue-400", bg: "bg-blue-500/20", border: "border-blue-500/30" },
  4: { label: "Challenging", color: "text-orange-400", bg: "bg-orange-500/20", border: "border-orange-500/30" },
  5: { label: "Expert", color: "text-red-400", bg: "bg-red-500/20", border: "border-red-500/30" },
};

const TrekHero = ({ trek = {}, onBookNow, onConsultation }) => {
  const diffInfo = DIFFICULTY_LABELS[trek.difficulty] || DIFFICULTY_LABELS[3];

  return (
    <div className="relative h-screen min-h-[680px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={trek.heroImage}
          alt={trek.name}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 h-full flex items-end pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-3xl">
            <div className="flex items-center gap-3 mb-4 flex-wrap">
              <span className="px-3 py-1 bg-white/15 backdrop-blur-sm text-white text-xs font-semibold rounded-full border border-white/20">
                {trek.category}
              </span>
              <span className={`px-3 py-1 ${diffInfo.bg} ${diffInfo.color} ${diffInfo.border} text-xs font-semibold rounded-full border backdrop-blur-sm`}>
                {diffInfo.label}
              </span>
              {trek.difficulty && (
                <div className="flex items-center gap-1">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <Icon
                      key={i}
                      name="Mountain"
                      size={14}
                      className={i <= trek.difficulty ? "text-accent" : "text-white/30"}
                    />
                  ))}
                </div>
              )}
            </div>

            <h1 className="font-headline text-5xl md:text-7xl text-white mb-3 leading-[0.92]">
              {trek.name}
            </h1>

            <p className="text-xl md:text-2xl text-white/80 mb-6 font-body max-w-2xl leading-relaxed">
              {trek.subtitle}
            </p>

            <div className="flex flex-wrap gap-5 mb-8">
              <div className="flex items-center gap-2 text-white/90">
                <div className="w-9 h-9 rounded-lg bg-white/10 backdrop-blur-sm flex items-center justify-center">
                  <Icon name="Calendar" size={16} />
                </div>
                <div>
                  <p className="text-xs text-white/60">Duration</p>
                  <p className="text-sm font-semibold">{trek.duration} Days</p>
                </div>
              </div>
              <div className="flex items-center gap-2 text-white/90">
                <div className="w-9 h-9 rounded-lg bg-white/10 backdrop-blur-sm flex items-center justify-center">
                  <Icon name="TrendingUp" size={16} />
                </div>
                <div>
                  <p className="text-xs text-white/60">Max Altitude</p>
                  <p className="text-sm font-semibold">{trek.maxAltitude}</p>
                </div>
              </div>

              <div className="flex items-center gap-2 text-white/90">
                <div className="w-9 h-9 rounded-lg bg-white/10 backdrop-blur-sm flex items-center justify-center">
                  <Icon name="MapPin" size={16} />
                </div>
                <div>
                  <p className="text-xs text-white/60">Region</p>
                  <p className="text-sm font-semibold">{trek.region}</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                variant="default"
                size="lg"
                className="btn-conversion text-base px-8"
                iconName="Calendar"
                iconPosition="left"
                onClick={onBookNow}
              >
                Book This Trek
              </Button>
              <Button
                variant="outline"
                size="lg"
                className="text-white border-white/40 hover:bg-white hover:text-primary text-base px-8"
                iconName="MessageCircle"
                iconPosition="left"
                onClick={onConsultation}
              >
                Free Consultation
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/60 animate-bounce">
        <Icon name="ChevronDown" size={24} />
      </div>
    </div>
  );
};

export default TrekHero;
